import 'pagiflow';
import { NgModule } from '@angular/core';
import { PagiflowComponent, PagiflowSlideComponent } from './Pagiflow';

// ─── Components ───────────────────────────────────────────────────────────────
export { PagiflowComponent } from './Pagiflow';
export { PagiflowSlideComponent } from './Pagiflow';


@NgModule({
  imports: [PagiflowComponent, PagiflowSlideComponent],
  exports: [PagiflowComponent, PagiflowSlideComponent],
})
export class PagiflowModule {}

// ─── Composable ────────────────────────────────────────────────────────────────
export { usePagiflow } from './usePagiflow';
export type { UsePagiflowReturn } from './usePagiflow';

// ─── Types ────────────────────────────────────────────────────────────────────
export type {
  PagiflowOptions,
  PagiflowInstance,
  PagiflowThumbnailOptions,
  PagiflowNavigationOptions,
  PagiflowDirection,
  PagiflowAutoScrollDirection,
  PagiflowResponsiveOptions,
} from './types';
